export default __webpack_public_path__ + "static/media/menu_btn.a6f5a99d.svg";